module.exports = __webpack_public_path__ + "img/logo_white.849d5f0b.svg";